export const useConfirmDialogLazyLoad = createLazyLoadState();
